export default __webpack_public_path__ + "static/media/alreadyAccepted.4bb383af.svg";